<div class="header">
  <h2>{{this.model.name}}</h2>
  <span class="flex-spacer"></span>
  <span class="assignees">{{this.assignees}}</span>
  <button type="button"
          aria-label="Close"
          (click)="this.close()"
          disableRipple
          mat-flat-button>
    <mat-icon aria-hidden="false">close</mat-icon>
  </button>
</div>

<div class="task-details">{{this.model.details}}</div>

<mat-nav-list class="actions" *ngIf="this.isAnnotatable">
  <a mat-list-item (click)="this.editOperatorNote()">
    <mat-icon mat-list-icon>comment</mat-icon>
    <span mat-line>{{this.hasNote? "Edit" : "Add"}} Note</span>
  </a>

  <a mat-list-item *ngIf="this.hasNote" (click)="this.removeOperatorNote()">
    <mat-icon mat-list-icon>backspace</mat-icon>
    <span mat-line>Remove Note</span>
  </a>
</mat-nav-list>

